// extracted by mini-css-extract-plugin
export default {"crLoadingOverlay":"CrLoadingOverlay_crLoadingOverlay__BdghQ","opaque":"CrLoadingOverlay_opaque__8vGNH"};